var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_600_12051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.567,
    cy: 23.5668,
    r: 22.65,
    transform: "rotate(-90 23.567 23.5668)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_600_12051)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.916992,
    y: 0.916992,
    width: 45.3,
    height: 45.3,
    fill: "#004692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5459 6.30713L22.4206 8.8523L19.7708 9.19095L21.7253 11.1027L21.2127 13.8571L23.5458 12.2842L25.879 13.8571L25.3664 11.1027L27.3208 9.19095L24.6711 8.8523L23.5459 6.30713Z",
    fill: "#F1B434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9953 10.263L12.8701 12.8082L10.2203 13.1468L12.1747 15.0586L11.6622 17.813L13.9953 16.2401L16.3284 17.813L15.8159 15.0586L17.7703 13.1468L15.1205 12.8082L13.9953 10.263Z",
    fill: "#F1B434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0397 19.8132L8.91444 22.3584L6.26465 22.6971L8.21907 24.6088L7.70653 27.3632L10.0396 25.7903L12.3728 27.3632L11.8602 24.6088L13.8146 22.6971L11.1649 22.3584L10.0397 19.8132Z",
    fill: "#F1B434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9953 29.3635L12.8701 31.9087L10.2203 32.2473L12.1747 34.1591L11.6622 36.9135L13.9953 35.3406L16.3284 36.9135L15.8159 34.1591L17.7703 32.2473L15.1205 31.9087L13.9953 29.3635Z",
    fill: "#F1B434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5459 33.3194L22.4206 35.8645L19.7708 36.2032L21.7253 38.1149L21.2127 40.8694L23.5458 39.2964L25.879 40.8694L25.3664 38.1149L27.3208 36.2032L24.6711 35.8645L23.5459 33.3194Z",
    fill: "#F1B434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0958 29.3635L31.9706 31.9087L29.3208 32.2473L31.2752 34.1591L30.7627 36.9135L33.0958 35.3406L35.4289 36.9135L34.9164 34.1591L36.8708 32.2473L34.221 31.9087L33.0958 29.3635Z",
    fill: "#F1B434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0517 19.8133L35.9265 22.3584L33.2767 22.6971L35.2311 24.6088L34.7186 27.3633L37.0517 25.7903L39.3848 27.3633L38.8723 24.6088L40.8267 22.6971L38.1769 22.3584L37.0517 19.8133Z",
    fill: "#F1B434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0958 10.263L31.9706 12.8082L29.3208 13.1468L31.2752 15.0586L30.7627 17.813L33.0958 16.2401L35.4289 17.813L34.9164 15.0586L36.8708 13.1468L34.221 12.8082L33.0958 10.263Z",
    fill: "#F1B434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/EUR.69361b22f68f572b777c9746460df952.svg";
export { ForwardRef as ReactComponent };